import T from "prop-types";
import { lifecycle, compose, defaultProps } from "recompose";

import { getResearchData } from "./researchData";
import { ResearchStory as ResearchStoryStyle } from "./ResearchStoryStyle";

function componentDidMount() {
  getResearchData(this.props, this.setState.bind(this));
}

function componentWillReceiveProps(props) {
  getResearchData(props, this.setState.bind(this));
}

function ResearchStoryContainer(props) {
  const { match } = props;
  return <ResearchStoryStyle {...props} {...match.params} />;
}

ResearchStoryContainer.propTypes = {
  match: T.shape({
    params: T.object,
  }),
};

const enhance = compose(
  lifecycle({
    componentDidMount,
    componentWillReceiveProps,
  }),
  defaultProps({
    columns: [],
    data: [],
    content: {
      topButtons: [],
      buttons: [],
      footnotes: [],
      intros: [],
    },
  }),
);

export const UniversalRender = enhance(ResearchStoryContainer);
